import React from 'react';
import serialize from 'form-serialize';

var _contactForm;

const handleSubmit = (event) => {
  event.preventDefault();
  _contactForm = event.target;
  const formData = serialize(event.target, { hash: true });
  const data = `name=${formData.name}&email=${formData.email}&phone=${formData.phone || ''}&message=${formData.message}`;

  fetch('https://buildgreenalbania.org/blogMng.php?/postEmail', {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
    body: data,
  }).then(
    () => { alert('Message received successfully! Thank you.'); clearFields(); },
    () => { alert('Could not send message. Please call us directly.'); clearFields(); },
  );
};

const clearFields = () => {
  ['email','name','message','phone'].forEach((f) => {
    if (_contactForm[f]) { _contactForm[f].value = ''; _contactForm[f].defaultValue = ''; }
  });
};

const SectionContacts = (props) => (
  <section className="bgg-contact-section" id="contact">
    <div className="bgg-container">
      <div className="bgg-section-header">
        <span className="bgg-section-label">Reach Us</span>
        <div>
          <h2 className="bgg-section-title">{props.contactTitle || 'Get In Touch'}</h2>
        </div>
      </div>

      <div className="bgg-contact-grid">
        {/* Contact form */}
        <div className="bgg-contact-form-card">
          <div className="bgg-contact-form-header">
            <h3>
              <i className="fas fa-envelope" style={{ marginRight: 10 }} />
              {props.writeUs || 'Write to Us'}
            </h3>
            <p>We'll get back to you within 1-2 business days.</p>
          </div>
          <div className="bgg-contact-form-body">
            <form onSubmit={handleSubmit}>
              <div className="bgg-form-group">
                <label className="bgg-form-label">Your Name</label>
                <input className="bgg-form-input" type="text" name="name" required placeholder="John Doe" />
              </div>
              <div className="bgg-form-group">
                <label className="bgg-form-label">Email Address</label>
                <input className="bgg-form-input" type="email" name="email" required placeholder="you@example.com" />
              </div>
              <div className="bgg-form-group">
                <label className="bgg-form-label">Phone (optional)</label>
                <input className="bgg-form-input" type="tel" name="phone" placeholder="+355 69 xxx xxxx" />
              </div>
              <div className="bgg-form-group">
                <label className="bgg-form-label">Message</label>
                <textarea className="bgg-form-textarea" name="message" required placeholder="How can we help?" />
              </div>
              <button type="submit" className="bgg-btn bgg-btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                <i className="fas fa-paper-plane" /> Send Message
              </button>
            </form>
          </div>
        </div>

        {/* Map + contact info */}
        <div>
          <div className="bgg-map-wrap">
            <iframe
              src="https://maps.google.com/maps?width=100%&height=600&hl=en&coord=41.318868,19.814860&q=Rruga%20%22Nikolla%20Tupe%22%2C%20P%C3%ABrball%C3%AB%20nj%C3%ABsis%C3%AB%20bashkiake%20nr.%205%2C%20Tiran%C3%AB%20Shqip%C3%ABri+(Build%20Green%20Albania%20)&ie=UTF8&t=&z=18&iwloc=B&output=embed"
              title="Build Green Group Albania location"
              width="100%"
              height="100%"
              frameBorder="0"
              loading="lazy"
              style={{ border: 0 }}
            />
          </div>

          <div className="bgg-contact-info-block">
            <div className="bgg-contact-info-item">
              <div className="bgg-contact-info-icon">
                <i className="fas fa-map-marker-alt" />
              </div>
              <p>Rruga Nikolla Tupe, Tirana, Albania</p>
            </div>
            <div className="bgg-contact-info-item">
              <div className="bgg-contact-info-icon">
                <i className="fas fa-envelope" />
              </div>
              <p>contact@buildgreenalbania.org</p>
            </div>
            <div className="bgg-contact-info-item">
              <div className="bgg-contact-info-icon">
                <i className="fas fa-globe" />
              </div>
              <p>buildgreenalbania.org</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default SectionContacts;



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionContacts.jsx